const Equipment = () => {
  const equipList = [
    {
      img: "/images/equip1.png",
      title: "대성 청음기",
    },
    {
      img: "/images/equip2.png",
      title: "구터만 청음기",
    },
    {
      img: "/images/equip3.png",
      title: "구터만\u00A0가스탐지기\u00A0세트",
    },
    {
      img: "/images/equip4.png",
      title: "구터만 가스탐지기",
    },
    {
      img: "/images/equip5.png",
      title: "열화상 카메라",
    },
    {
      img: "/images/equip6.png",
      title: "수도배관\u00A0내시경",
    },
    {
      img: "/images/equip7.png",
      title: "고압세척기",
    },
    {
      img: "/images/equip8.png",
      title: "리지드\u00A0하수배관\u00A0내시경",
    },
    {
      img: "/images/equip9.png",
      title: "리지드 배관세척기",
    },
    {
      img: "/images/equip10.png",
      title: "대성 수도배관 내시경",
    },
  ];
  return (
    <div
      id="equip"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20 text-black"
      >
        <div className="relative w-fit h-fit mx-auto">
          <img
            src="/images/logo.png"
            alt="장인배관 로고"
            width={247}
            height={58}
            className="!relative w-full h-auto max-w-32"
          />
        </div>
        <h2 className="font-light my-3">장인배관의 장비현황</h2>
      </div>
      <div className="relative w-full h-full grid grid-cols-2 lg:grid-cols-5 lg:grid-rows-2 gap-7 px-[calc((100%-var(--container))/2)]">
        {equipList.map((v, i) => (
          <div
            data-aos="fade-up"
            key={i}
            className=" relative w-full h-full grid justify-items-center"
          >
            <div className="relative w-fit h-fit rounded-full border-8 border-primary mb-3 overflow-hidden ">
              <img
                src={v.img}
                alt={`장인배관 누수탐지 장비 - ${v.title}`}
                className="hover:scale-110 transition-transform duration-200 !relative w-full h-auto max-w-32 lg:max-w-none"
              />
            </div>
            <p className="text-black">{v.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Equipment;
